import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getScontisticheCorso(uname, token, idCorso) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getScontisticheCorso.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        try {
          // Modifica qui: invece di utilizzare Utils.unescapeString, facciamo il parsing diretto
          const bodyStr = body.toString();
          const resp = JSON.parse(bodyStr);
          resolve(resp);
        } catch (error) {
          console.error("Errore nel parsing della risposta:", error);
          console.error(
            "Contenuto ricevuto:",
            body.toString().substring(0, 100) + "..."
          );
          resolve({ result: "error", scontistiche: "" });
        }
      });

      res.on("error", function(error) {
        console.error("Errore nella richiesta:", error);
        resolve({ result: "error", scontistiche: "" });
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_corso: idCorso,
    });

    req.write(postData);
    req.end();
  });
}
